<template>
  <div>
    <wc-data-box
      title='Connected Contacts'
      :titleIcon='$store.state.icons.modules.clients.icon'
      :titleIconColor='$store.state.icons.modules.clients.color'
      :loading='isLoading'
      showHelp
      :helpText='helpText'
      showAdd
      @add='edit'
    >
      <v-simple-table dense v-if='contacts.length'>
        <tbody>
          <tr v-for='(contact, index) in contacts' :key='index'>
            <td :class='label' @click='edit(contact)'>{{ contact.position }}</td>
            <td :class='dataValue'>
              {{ contact.contact_obj.name_display }}
              <v-btn icon small @click="contactCard(contact)">
                <v-icon color='grey'>{{ contactIcon }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text v-else>None found...</v-card-text>
    </wc-data-box>

    <wc-contact-card
      :contact='contact'
      :showDialog='showCard'
      @close='closeCard'
    ></wc-contact-card>

    <wc-dialog
      :showDialog='showDialog'
      :title='(clientContactCopy.id ? "Edit" : "Add New") + " Contact Relationship"'
      icon='mdi-account'
      @cancel='cancel'
      @save='save'
      :disableButtons='!isFormValid || isLoading'
      :loadingButtons='isLoading'
    >
      <template v-slot:dialog-actions v-if='clientContactCopy.id'>
        <v-btn text @click='showConfirmDelete=true' color='error'>Delete</v-btn>
      </template>
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <client-form-search
              ref='clientPicker'
              v-model='clientContactCopy.contact'
              label='Choose a Contact'
              :company='false'
              required
              @loading='setLoading'
            ></client-form-search>
            <!-- <v-autocomplete
              :loading='gettingContactList'
              :items='contactsPickList'
              item-value='id'
              item-text='name_display'
              :rules='[rules.required]'
              label="Choose a Contact"
              v-model='clientContactCopy.contact'
              :menu-props='{ top: true }'
              :persistent-hint='gettingContactList'
              :hint='gettingContactList ? "getting contacts data" : "start typing to filter results"'
            ></v-autocomplete> -->
          </v-col>
          <v-col cols='12'>
            <v-text-field
              label='Role'
              :rules='[rules.required]'
              v-model='clientContactCopy.position'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

    <wc-confirm
      :showDialog='showConfirmDelete'
      @cancel='showConfirmDelete = false'
      @confirm='deleteClientContact'
      :loading='isDeleting'
    >
      Are you sure you want to delete this company to contact link?
    </wc-confirm>

  </div>
</template>

<script>
import _ from 'lodash'
import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import clientsAPI from '@/modules/clients/api/clients'
import WCContactCardDialog from '@/components/dialogs/WCContactCardDialog'
import ClientFormSearch from '@/modules/clients/components/ClientFormSearch'

export default {
  name: 'client-contacts',
  mixins: [formRules],
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    // gettingContactList: false,
    showConfirmDelete: false,
    isDeleting: false,
    showDialog: false,
    isFormValid: false,
    contacts: [],
    // contactsPickList: [],
    showCard: false,
    contactIcon: 'mdi-account-circle',
    label: 'grey--text',
    dataValue: 'text-right pr-2',
    contact: {},
    clientContactCopy: {},
    helpText: 'Individuals who might not specifically work for the company, but you want to link them to this page.<br><br>Click on the left side of the row to edit an entry' 
  }),
  computed: {

  },
  mounted () {
    this.getContacts()
  },
  methods: {
    async getContacts () {
      this.isLoading = true
      this.contacts = await clientsAPI.getClientContacts(this.client.id)
      this.isLoading = false
    },
    contactCard (contact) {
      this.contact = _.cloneDeep(contact.contact_obj)
      this.contact.contact_type = contact.position
      this.showCard = true
    },
    closeCard () {
      this.showCard = false
    },
    cancel () {
      this.$refs.clientPicker.clearResults()
      this.$refs.form.reset()
      this.showDialog = false
    },
    async save () {
      this.isLoading = true
      this.clientContactCopy.client = this.client.id
      if (this.clientContactCopy.id) {
        let tmp = await clientsAPI.updateClientContact(this.clientContactCopy)
        this.contacts = miscServices.replaceObject(this.contacts, tmp)
      } else {
        let tmp = await clientsAPI.createClientContact(this.clientContactCopy)
        this.contacts.push(tmp)
      }
      this.$refs.clientPicker.clearResults()
      this.$refs.form.reset()
      this.showDialog = false
      this.isLoading = false
    },
    async edit(contact = null) {
      if (contact) {
        this.clientContactCopy = _.cloneDeep(contact)
      } else {
        this.clientContactCopy = {}
      }
      this.showDialog = true
      // if (!this.contactsPickList.length) {
      //   this.gettingContactList = true
      //   this.contactsPickList = await clientsAPI.getIndividualClients()
      //   this.gettingContactList = false
      // }
    },
    async deleteClientContact () {
      this.isDeleting = true
      let tmp = await clientsAPI.removeClientContact(this.clientContactCopy)
      this.contacts = miscServices.removeObject(this.contacts, tmp)
      this.$refs.clientPicker.clearResults()
      this.$refs.form.reset()
      this.isDeleting = false
      this.showConfirmDelete = false
      this.showDialog = false
    },
    setLoading (val) {
      this.isLoading = val
    }
  },
  components: {
    'wc-contact-card': WCContactCardDialog,
    'client-form-search': ClientFormSearch
  }
}
</script>